import ClientLogo from '@assets/images/Logo.svg';

export const Logo: React.FC<{}> = () => (
  <ClientLogo className="shrink-0 md:h-[40px] md:w-[216px]" />
);
